var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAyuda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 13.74C11.0833 14.43 10.5533 15 9.83325 15C9.13325 15 8.57325 14.44 8.57325 13.74C8.57325 13.03 9.13325 12.49 9.83325 12.49C10.5433 12.49 11.0833 13.04 11.0833 13.74ZM9.82325 3C8.05325 3 6.84325 4.15 6.39325 5.49L8.03325 6.18C8.25325 5.51 8.77325 4.7 9.83325 4.7C11.4533 4.7 11.7733 6.22 11.2033 7.03C10.6633 7.8 9.73325 8.32 9.24325 9.19C8.85325 9.88 8.93325 10.68 8.93325 11.17H10.7533C10.7533 10.24 10.8233 10.05 10.9733 9.76C11.3633 9.04 12.0833 8.7 12.8433 7.59C13.5233 6.59 13.2633 5.23 12.8233 4.51C12.3133 3.67 11.3033 3 9.82325 3ZM16.8333 2H2.83325V16H16.8333V2ZM16.8333 0C17.9333 0 18.8333 0.9 18.8333 2V16C18.8333 17.1 17.9333 18 16.8333 18H2.83325C1.73325 18 0.833252 17.1 0.833252 16V2C0.833252 0.9 1.73325 0 2.83325 0H16.8333Z",
    fill: "#163C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyuda);
export default __webpack_public_path__ + "static/media/Ayuda.94e5b9babf11281cc326da3fd60ac087.svg";
export { ForwardRef as ReactComponent };